<script lang="ts">
	import { drawerState } from 'src/stores/ui/sidepanel-public';
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
import { devices } from 'src/stores/lists/devices';
	import { btHomeRemoteIcon } from 'src/stores/features/ble/bt-home-remote-icon';
	import StatusIcons from '../GenericStatusesIcons/StatusIcons.svelte';
	import { buildRawStatusIcon } from '../GenericStatusesIcons/statusListBuilder';
	import { real_id } from 'src/helpers/interface_helpers';

	$: id = $drawerState.id;
	$: deviceRealId = id ? real_id(id) : undefined;
	$: remoteIconEntry = deviceRealId && $btHomeRemoteIcon ? $btHomeRemoteIcon[deviceRealId] : undefined;
	$: statusStore = getDeviceStatus(id);
	$: settingsStore = getDeviceSettings(id);
	$: icons = buildRawStatusIcon(
		$devices[id],
		$statusStore,
		$settingsStore,
		'drawer',
		{
			hasMappedRemotesOverride: remoteIconEntry?.active,
		},
	).map(({ icon, active }) => ({ icon, active }));
</script>

{#if icons}
	<StatusIcons deviceSettings={$settingsStore} {id} {icons} />
{/if}
